module.exports = __webpack_public_path__ + "f6d857e1d647ac5f22d210fc9d350188.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/history/fi-2004.png
// module id = 382
// module chunks = 0